module.exports = "<div class=\"row\">\n    <div class=\"col-md-12\">\n        <div class=\"panel panel-default blnd-panel\">\n            <div class=\"panel-body\">\n                <form>\n                    <div class=\"form-group\">\n                        <textarea class=\"form-control notes\" ng-blur=\"vm.submit()\" ng-model=\"vm.data.notes\"></textarea>\n                    </div>\n                    <button class=\"btn btn-submit pull-right\" ng-click=\"vm.submit()\">Save</button>\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/orders/templates/detail.notes.html
// module id = 639
// module chunks = 0